/**
 * Text a delivered file prints, the same in every browser (M4S-5777 X13).
 *
 * `toLocaleString()` with no locale formats by the machine it runs on: 1,234 in the US, 1.234 in
 * Germany, 1 234 in France, and a date in each place's own order and zone. Two people exporting
 * one crosstab got two different files. Counts and times written into a file go through here,
 * with a fixed locale and ISO times, so the file is the same wherever it was made.
 *
 * The screen keeps the person's own locale; only file text is fixed.
 *
 * Pure.
 */

const COUNT = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0, useGrouping: true });

/** A whole count with thousands separators, the same in every locale: 1234 → "1,234". */
export function formatCount(n: number): string {
    return Number.isFinite(n) ? COUNT.format(Math.round(n)) : '–';
}

/**
 * A time as ISO 8601 in UTC, to the second: "2026-10-17T16:05:00Z". UTC, not the writer's clock,
 * so one time reads the same in a file made anywhere; a reader converts it. An invalid or missing
 * time is ''.
 */
export function isoUtc(at: Date | string | number | null | undefined): string {
    if (at === null || at === undefined || at === '') return '';
    const d = at instanceof Date ? at : new Date(at);
    const ms = d.getTime();
    if (!Number.isFinite(ms)) return '';
    return new Date(Math.floor(ms / 1000) * 1000).toISOString().replace('.000Z', 'Z');
}
